import { ModelBase } from '../../core/model/model-base';

export enum LocationAccessGroupLevel {
  company = 0,
  property = 1,
}

export class LocationAccessRow extends ModelBase {
  caption: string;
  accessEntityId: string;
}

export class LocationAccessGroupMember extends ModelBase {
  webUserId: string;
  personName: string;
  userName: string;
}

export class LocationAccessGroup extends ModelBase {
  constructor() {
    super();
    this.configurationLevel = LocationAccessGroupLevel.company;
  }

  configurationLevel: LocationAccessGroupLevel;
  name: string;
  members: LocationAccessGroupMember[] | string[] = [];
  accessRows: LocationAccessRow[] | string[] = [];

  toString() {
    return this.name;
  }
}
